import * as React from "react";
import * as Icons from "../_assets/icons";

// TODO: Use advanced type for type to avoid code duplication
export interface IIconSVG {
  type:
    | "autoplay"
    | "close"
    | "gamerules"
    | "gamehistory"
    | "gamesettings"
    | "home"
    | "intromovie"
    | "introscreen"
    | "lefthandmode"
    | "menu"
    | "paytable"
    | "play"
    | "quickspin"
    | "sound"
    | "spacebartospin"
    | "spin"
    | "stop"
    | "stop-small"
    | "plugin"
    | "for.testing"
    | "keyboardarrow";
  active?: boolean;
}

export const Icon = ({ type, ...props }: IIconSVG) => {
  switch (type) {
    case "autoplay":
      return <Icons.AutoplayIcon {...props} />;
    case "close":
      return <Icons.CloseIcon {...props} />;
    case "gamerules":
      return <Icons.GameRulesIcon {...props} />;
    case "gamehistory":
      return <Icons.GameHistoryIcon {...props} />;
    case "gamesettings":
      return <Icons.GameSettingsIcon {...props} />;
    case "home":
      return <Icons.HomeIcon {...props} />;
    case "intromovie":
      return <Icons.IntroMovie {...props} />;
    case "introscreen":
      return <Icons.IntroScreen {...props} />;
    case "lefthandmode":
      return <Icons.LeftHandMode {...props} />;
    case "menu":
      return <Icons.MenuIcon {...props} />;
    case "paytable":
      return <Icons.PaytableIcon {...props} />;
    case "play":
      return <Icons.PlayIcon {...props} />;
    case "plugin":
      return <Icons.PluginIcon {...props} />;
    case "quickspin":
      return props.active ? (
        <Icons.QuickSpinActiveIcon {...props} />
      ) : (
        <Icons.QuickSpinIcon {...props} />
      );
    case "sound":
      return props.active ? (
        <Icons.SoundActiveIcon {...props} />
      ) : (
        <Icons.SoundInactiveIcon {...props} />
      );
    case "spacebartospin":
      return <Icons.SpacebarToSpin {...props} />;
    case "spin":
      return <Icons.SpinIcon {...props} />;
    case "stop":
      return <Icons.StopIcon {...props} />;
    case "stop-small":
      return <Icons.StopIconSmall {...props} />;
    case "keyboardarrow":
      return <Icons.KeyboardArrow {...props} />;
    default:
      console.warn(type + " icon doesn't exist.");
      return <span />;
  }
};
